import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Gift, Ban, Loader2 } from "lucide-react";

export default function FreeAccessDialog({ target, busyId, onClose, onConfirm }) {
  const enabling = target && !target.lifetime_free; // true = kostenlos gewähren
  const label = target?.company || target?.email || "";
  return (
    <Dialog open={!!target} onOpenChange={(o) => (!o ? onClose() : null)}>
      <DialogContent data-testid="free-access-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {enabling ? (
              <Gift className="h-5 w-5 text-primary" />
            ) : (
              <Ban className="h-5 w-5 text-amber-600" />
            )}
            {enabling ? "Konto kostenlos stellen?" : "Kostenlosen Zugang entziehen?"}
          </DialogTitle>
          <DialogDescription>
            {enabling ? (
              <>
                Möchten Sie{" "}
                <span className="font-medium text-foreground">{label}</span>{" "}
                dauerhaft kostenlos stellen? Das Konto ist dann von Abo und Guthaben befreit. Der
                Kunde wird automatisch per E-Mail informiert.
              </>
            ) : (
              <>
                Möchten Sie den kostenlosen Zugang für{" "}
                <span className="font-medium text-foreground">{label}</span>{" "}
                entziehen? Danach gelten wieder die regulären Konditionen (Abo bzw. Guthaben). Der
                Kunde wird automatisch per E-Mail informiert.
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="free-access-cancel">
            Abbrechen
          </Button>
          <Button
            onClick={onConfirm}
            disabled={busyId === target?.id}
            className={
              enabling
                ? "bg-primary text-primary-foreground hover:bg-primary/90"
                : "bg-amber-600 text-white hover:bg-amber-700"
            }
            data-testid="free-access-confirm"
          >
            {busyId === target?.id ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : enabling ? (
              "Kostenlos stellen"
            ) : (
              "Entziehen"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
